import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const API_ROOT = '/api';

export const api = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ baseUrl: API_ROOT }),
  tagTypes: ['Forms'],
  endpoints: build => ({
    // FORMS
    viewForms: build.query({
      query: values => {
        let queryParams = [];
        if (values.id) {
          queryParams.push(['id', values.id]);
        }
        const query = queryParams.length ? `?${queryParams.map(q => q.join('=')).join('&')}` : '';

        return `/forms/${query}`;
      },
      providesTags: ['Forms'],
    }),
    addNewForm: build.mutation({
      query: values => {
        return {
          url: '/forms/new',
          method: 'POST',
          body: values,
        };
      },
      invalidatesTags: ['Forms'],
    }),
    editForm: build.mutation({
      query: values => {
        return {
          url: '/forms/edit',
          method: 'PUT',
          body: values,
        };
      },
      invalidatesTags: ['Forms'],
    }),
    deleteForm: build.mutation({
      query: values => {
        return {
          url: '/forms/delete',
          method: 'DELETE',
          body: values,
        };
      },
      invalidatesTags: ['Forms'],
    }),
    // SUBMISSIONS
    viewSubmissions: build.query({
      query: values => {
        let queryParams = [];
        if (values.id) {
          queryParams.push(['id', values.id]);
        }
        const query = queryParams.length ? `?${queryParams.map(q => q.join('=')).join('&')}` : '';

        return `/submissions/${query}`;
      },
    }),
    addSubmission: build.mutation({
      query: values => {
        return {
          url: '/submissions/new',
          method: 'POST',
          body: values,
        };
      },
    }),
    // ASANA
    viewAsanaProjects: build.query({
      query: () => '/asana/projects',
    }),
    // SLACK
    viewSlackChannels: build.query({
      query: () => '/slack/channels',
    }),
  }),
});

export const {
  useViewFormsQuery,
  useAddNewFormMutation,
  useEditFormMutation,
  useDeleteFormMutation,
  useViewSubmissionsQuery,
  useAddSubmissionMutation,
  useViewAsanaProjectsQuery,
  useViewSlackChannelsQuery,
} = api;
